import { render } from "./DocumentClassList.vue?vue&type=template&id=34f9e2ac&scoped=true&ts=true"
import script from "./DocumentClassList.vue?vue&type=script&lang=ts"
export * from "./DocumentClassList.vue?vue&type=script&lang=ts"

import "./DocumentClassList.vue?vue&type=style&index=0&id=34f9e2ac&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f9e2ac"]])

export default __exports__